import type { Address } from "viem";
import { useReadContract } from "wagmi";
const useNodesCount = (
	account: string,
	nodeControllerContractAddress: Address,
	abi,
) => {
	const { data } = useReadContract({
		abi: abi,
		address: nodeControllerContractAddress,
		args: [account],
		functionName: "getNodesCount",
	});

	return data ? +data?.toString() : 0;
};

export default useNodesCount;
